import React, { useCallback, useContext } from 'react'
import { MS_PER_MINUTE, castPromiseToItself, makeScheduleMatrix } from '@planda/design-system'
import { Flex } from '@radix-ui/themes'
import { startOfDay } from 'date-fns'
import { ChatContext } from '@/components'
import Loader from '@/components/Loader'
import { INCREMENT_BY_MINUTES } from '@/constants'
import AvailabilitiesTimegrid from '@/features/drag-calendar'
import { Mode } from '@/features/drag-calendar/utils'
import { fetcher } from '@/lib/fetch'
import { useAuthSWR } from '@/lib/swr'
import { AvailabilityBlock } from '@/types'

const ManualFill = () => {
  const {
    user
  } = useContext(ChatContext)
  const { userId } = user || {}
  const { data: myData, isLoading: myIsLoading, mutate } = useAuthSWR<{ start: number, overlay: number[][] }>(userId, `/api/user/availabilities`)
  const handleEdit = useCallback((dates: number[], state: Mode) => {
    const blocks: AvailabilityBlock[] = dates.map(date => {
      if (state === null) console.log("state is null", state, dates)
      return {
        dateStart: date,
        priority: state || 0,
      }
    })

    const promise = fetcher(`/api/user/availabilities/manual?userid=${userId}`, 'PATCH', { blocks })
    const promiseCast = castPromiseToItself(promise, `/api/user/availabilities?userid=${userId}`)
    mutate(promiseCast, {
      optimisticData: (data) => {
        // if (!data) return {
        //     start: Date.now(),
        //     overlay: makeScheduleMatrix(0, 15)
        // }
        const oldOverlay = data ? data.overlay : makeScheduleMatrix(0, 15)
        const { start = startOfDay(Date.now()).getTime() } = data || {}
        const newOverlay = [...oldOverlay.map(row => [...row])]
        blocks.forEach(block => {
          const dayOrder = Math.round((block.dateStart - start) / (15 * MS_PER_MINUTE))
          const rowIndex = Math.floor(dayOrder / (24 * 4))
          if (rowIndex >= newOverlay.length) {
            console.log("fail to assign", block, dayOrder, rowIndex, newOverlay.length)
          }
          const colIndex = dayOrder % (24 * 4)
          newOverlay[rowIndex][colIndex] = block.priority
        })
        return { overlay: newOverlay, start: start }
      }
    })
  }, [mutate, userId])

  const start = myData?.start || startOfDay(Date.now()).getTime()
  const overlay = myData?.overlay || makeScheduleMatrix(0, INCREMENT_BY_MINUTES)

  return (
    <Flex className={'py-2'} direction="column" gap="3" style={{ flexBasis: 500, flex: 1, maxHeight: '100%', background: 'var(--color-background)' }} >
      {/* <Heading>Availabilities Table</Heading> */}
      {/* {(myIsLoading && !myData) && <Loader className='absolute' />} */}
      <AvailabilitiesTimegrid handleEdit={handleEdit} firstDay={start} myOverlay={overlay} isLoading={myIsLoading && !myData} />
    </Flex>
  )
}

export default ManualFill
